package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.Route
import com.milta.feature.route.domain.repository.RouteRepository

/**
 * GET /api/v1/routes/{id} — route detail (MIL-38). Shared by a Driver viewing their own route and
 * an Enterprise manager viewing any route of their tenant; ownership/tenant-membership is enforced
 * server-side, this use case has no role-specific branching.
 */
class GetRouteDetailUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String): Route = repository.getRouteById(routeId)
}
